import styled from "@emotion/styled";
import { bool, node } from "prop-types";
import React from "react";
import { Col, Row } from "react-flexbox-grid";

import theme from "../../theme";
import { bodyLarge, h4 } from "../Typography";

const Wrapper = styled.div``;

const IntroRow = styled(Row)`
  margin-bottom: ${theme.spacing("m")};
`;

const IntroText = styled.p`
  ${h4};
`;

const MainText = styled.p`
  ${bodyLarge};
`;

const TwoText = ({
  intro,
  body,
  introhtml = false,
  html = false,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      {intro && (
        <IntroRow>
          <Col xs={12} sm={8} md={6} lg={5} mdOffset={0}>
            {introhtml ? (
              <IntroText
                as={introhtml ? "div" : "p"}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            ) : (
              <IntroText>{intro}</IntroText>
            )}
          </Col>
        </IntroRow>
      )}
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          {html ? (
            <MainText
              as={html ? "div" : "p"}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          ) : (
            <MainText>{body}</MainText>
          )}
        </Col>
      </Row>
    </Wrapper>
  );
};

TwoText.propTypes = {
  intro: node,
  body: node.isRequired,
  html: bool,
  introhtml: bool,
};

export default TwoText;
